import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { useApplication } from "../../context/ApplicationContext";
import { toast } from "sonner";
export default function SharedSettings() {
  const app = useApplication(),
    [form, setForm] = useState(null),
    can = app.permissionKeys.includes("config.shared_settings.update");
  useEffect(() => {
    api.get("/config/shared-settings").then(({ data }) => setForm(data));
  }, []);
  if (!form) return <p>Loading shared settings…</p>;
  const field = (label, name) => (
    <label className="block text-sm font-semibold">
      {label}
      <input
        disabled={!can}
        value={form[name] || ""}
        onChange={(e) => setForm({ ...form, [name]: e.target.value })}
        className="mt-2 w-full rounded-lg border p-3 font-normal"
      />
    </label>
  );
  return (
    <div className="mx-auto max-w-3xl space-y-6">
      <header>
        <p className="text-xs font-bold uppercase tracking-[.2em] text-indigo-600">
          Configlution / Shared settings
        </p>
        <h1 className="mt-2 text-3xl font-black">Organisation defaults</h1>
        <p className="mt-2 text-sm text-slate-600">
          Cross-Lution defaults belong here; personal display preferences remain
          within each Lution.
        </p>
      </header>
      <div className="space-y-5 rounded-2xl border bg-white p-6">
        {field("Default timezone", "default_timezone")}
        {field("Date format", "date_format")}
        {can && (
          <button
            onClick={async () => {
              await api.patch("/config/shared-settings", form);
              toast.success("Shared settings saved");
            }}
            className="rounded-lg bg-slate-950 px-5 py-2.5 font-semibold text-white"
          >
            Save defaults
          </button>
        )}
      </div>
    </div>
  );
}
